import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/fund/pay/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/fund/pay/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/fund/pay/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/fund/pay/submit', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/fund/pay/submit', params,options)

export const queryResult = (params, options) =>
  request.get('/api/v4ward/propertypay/v2/querychannel', Object.assign({}, options, { params }))
